export const GET_FIBRE_LINKS_URL = `https://www.tizeti.com/williams_rd/mobile_api/dashboard_api.php`;